export const NotificationItem = ({
  notificationItem,
  defaultChecked,
  handleChange,
  auto_buy,
}) => {
  return (
    <div className="notification-row">
      <p className="notification-row-description">
        {notificationItem.description}
      </p>
      <input
        type="checkbox"
        id={notificationItem.id}
        name="notifications"
        defaultChecked={defaultChecked}
        onClick={() => handleChange(notificationItem.key)}
        className={
          auto_buy
            ? "notifications-row-checkbox-disabled"
            : "notifications-row-checkbox"
        }
        disabled={auto_buy ? "disabled" : ""}
        style={{}}
      />
    </div>
  );
};
